// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  TableRow,
  TableCell,
  Table,
  Divider,
  Checkbox,
  ListItemText,
  ListItem,
  Chip,
  Stack,
  ListItemAvatar,
  TableContainer,
  TableHead,
  TableBody,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

export default function CallCenterTeamPerformancePage() {
  const pageTitle = "Call Center - Team Performance";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);

  const [callCenter, setCallCenter] = useState(null);
  const [groupStats, setGroupStats] = useState([]);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/call_centers/${ref}/groups/performance.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result.data.data);
          if (result.data.status === "success") {
            setCallCenter(result.data.data.call_center);
            setGroupStats(result.data.data.group_stats);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function getAgentPerfomances(groupRef) {
    setShowLoading(true);
    await axios
      .get(`portal/voice/call_centers/${groupRef}/agents/performance.json`)
      .then(async (result) => {
        setShowLoading(false);
        console.log(result.data.data);
        if (result.data.status === "success") {
          setAgents(result.data.data.agent_stats);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    if (selectedGroup === null) {
      return;
    }

    getAgentPerfomances(selectedGroup);
  }, [selectedGroup]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox mt={0} mb={1.5} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/voice/call-centers/${ref}`);
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox align="right" pr={2}>
            <MDTypography variant="body2" fontSize={12}>
              Team performance
            </MDTypography>
            <MDTypography variant="h6">{callCenter?.title}</MDTypography>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox>
                    <MDTypography variant="h6">Group Performance</MDTypography>
                  </MDBox>
                  <MDBox mt={2}>
                    <Table>
                      <TableRow>
                        <TableCell>
                          <b>Group</b>
                        </TableCell>
                        <TableCell>
                          <b>Inbound</b>
                        </TableCell>
                        <TableCell>
                          <b>Outbound</b>
                        </TableCell>
                        <TableCell>
                          <b>Total</b>
                        </TableCell>
                      </TableRow>
                      {groupStats.map((stat) => (
                        <TableRow>
                          <TableCell>{stat.group}</TableCell>
                          <TableCell>{stat.inbound}</TableCell>
                          <TableCell>{stat.outbound}</TableCell>
                          <TableCell>{stat.inbound + stat.outbound}</TableCell>
                        </TableRow>
                      ))}
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card>
                <MDBox>
                  <MDBox display="flex" justifyContent="space-between" p={2}>
                    <MDBox>
                      <MDTypography variant="h6">Agent Performance</MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDInput
                        select
                        label="Select Group"
                        onChange={(e) => {
                          setSelectedGroup(e.target.value);
                        }}
                        fullWidth
                        SelectProps={{ style: { padding: "12px 0px" } }}
                        sx={{ minWidth: "120px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        {groupStats.map((stat) => (
                          <MenuItem value={stat.reference}>{stat.group}</MenuItem>
                        ))}
                      </MDInput>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={2}>
                    <TableContainer
                      sx={{
                        width: "100%",
                        maxWidth: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                      }}
                       mb={3}
                    >
                      <Table
                        stickyHeader
                        size="small"
                        sx={{
                          // minWidth: 1160,
                          tableLayout: "auto",
                          "& .MuiTableCell-root": {
                            // whiteSpace: "nowrap",
                            py: 0.80,
                            px: 1.25,
                            fontSize: "0.85rem", // smaller text across the table
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700 }}>Agent</TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            In
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Out
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Missed
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Score
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700, minWidth: 120 }}>
                            Customer Sentiment
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Professionalism
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Listening
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Clarity
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Control
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 700 }}>
                            Empathy
                          </TableCell>
                        </TableRow>

                        {agents.map((stat, index) => (
                          <TableRow
                            key={stat.reference}
                            hover
                            sx={{
                              backgroundColor: index % 2 === 0 ? "background.paper" : "grey.50",
                            }}
                          >
                            <TableCell>
                              <MDTypography variant="caption" fontWeight="medium">
                                {stat.agent}
                              </MDTypography>
                            </TableCell>

                            <TableCell align="center">{stat.inbound}</TableCell>

                            <TableCell align="center">{stat.outbound}</TableCell>

                            <TableCell align="center">
                              <MDTypography
                                variant="caption"
                                fontWeight="medium"
                                color={stat.missed > 0 ? "warning" : "text"}
                              >
                                {stat.missed}
                              </MDTypography>
                            </TableCell>

                            <TableCell align="center">
                              <MDTypography variant="caption" fontWeight="bold">
                                {stat.score}
                              </MDTypography>
                            </TableCell>

                            <TableCell align="center">
                              <Chip
                                label={stat.sentiment.toUpperCase()}
                                size="small"
                                color={
                                  stat.sentiment === "POSITIVE"
                                    ? "success"
                                    : stat.sentiment === "NEGATIVE"
                                    ? "error"
                                    : "default"
                                }
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "0.64rem",
                                  height: 20,
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">{stat.professionalism}</TableCell>
                            <TableCell align="center">{stat.listening}</TableCell>
                            <TableCell align="center">{stat.clarity}</TableCell>
                            <TableCell align="center">{stat.control}</TableCell>
                            <TableCell align="center">{stat.empathy}</TableCell>
                          </TableRow>
                        ))}
                      </Table>
                    </TableContainer>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
